export default {
  ggtitle: {
    gsgg: '公司公告',
    bzj: '保证金公告',
    jys: '交易所公告'
  },
  tzzjytitle: {
    qhrm: '新手上路',
    jyjj: '交易进阶',
    fxjs: '风险揭示',
    flfg: '法律法规',
    ycjy: '交易规则', // 异常交易更名为交易规则 2020.03.24
    qhjglc: '期货交割',
    skgx: '实控关系',
    qqtd: '期权天地',
    fxqzl: '反洗钱',
    yyqh: '原油期货'
  },
  xxgstitle: {
    gsxx: '公司信息',
    glry: '管理人员',
    cyry: '从业人员',
    cwxx: '财务信息',
    gdxx: '股东信息',
    lsqk: '历史情况',
    fzjg: '分支机构',
    zgs: '子公司',
    cxjl: '诚信记录',
    qtgs: '其他公示'
  }
}



// WEBPACK FOOTER //
// ./src/common/title/title.js